
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import {
  ResultWrapper,
  SkeletonResult,
  PopularDestinationOffers,
  Contact,
  CompanyLogos,
  SearchBenefits,
  AboutUs,
  RecentSearchesWrapper,
  Banner,
  CustomGetaways,
  GetawayList
} from '@components';
import { SearchWrapper } from '@share/components';
import { CanImpersonate, IsImpersonating, RootState, LoginType, UrlUtils } from '@share/utils';
import { Responsive } from '@share/utils';
import { HotelsCompanyLogos } from '@common-types';
import { GetawaysLocationEnum, IAccount, PRIMARY_BANNER_TYPE, SECONDARY_BANNER_TYPE } from '@share/common-types';
import { LifeStyleMessage } from '@components';
import { NULL_VALUE } from '@constants';
import { ALL_INCLUSIVE_KEY, DEAL_HOME_LABEL } from '@share/constants';

import { FeaturedDestinations } from '../featured-destinations';

import './style.scss';

interface IProps {
  isVacationRentals: boolean;
}

export function SearchTravcoding(props: IProps) {

  const hotelsStore = useSelector((state: RootState) => state.hotelsStore);
  const benefitsStore = useSelector((state: RootState) => state.benefitsStore);
  const loginStore = useSelector((state: RootState) => state.loginStore);

  const values = UrlUtils.getValues();

  const { isVacationRentals } = props;
  const { hotels, loading, searchedLocation, error } = hotelsStore;
  const { account } = loginStore;
  
  const hasPublicAccessToken = account?.hasPublicAccessToken;
  const hideThingsMatterSection = account?.hideThingsMatterSection;
  const hasDisplayContactSection = account?.hasDisplayContactSection;
  const hasDisplayTrustedBrandsSection = account?.hasDisplayTrustedBrandsSection;
  const contactAssistants = account?.contactAssistants;
  const contactSectionBottom = contactAssistants?.sectionBottom || false;

  const hasPublicValidToken = account?.type !== LoginType.Public || !hasPublicAccessToken || !isEmpty(loginStore.accessToken);

  const showImpersonate = CanImpersonate(account as IAccount) && !IsImpersonating() && !account?.disableImpersonate && account?.forceImpersonate;

  return (
    <div className="search-travcoding">
      <SearchWrapper isVacationRentals={isVacationRentals} openOnClick={values[DEAL_HOME_LABEL] === ALL_INCLUSIVE_KEY} />
      {!hotels && (
        <>
          {(hasPublicValidToken && !showImpersonate) && (
            <RecentSearchesWrapper isVacationRentals={isVacationRentals} />)}

          {hasPublicValidToken && (
            <PopularDestinationOffers />)}

          {account?.displayGetawaysHomeHotels ?
            account?.displayGetawaysHomeHotelsSlider ? (
              <GetawayList
                getaway={GetawaysLocationEnum.Staycation}
                condoSubcategory={NULL_VALUE}
              
                isFromProperty
                isInternal
                isHome
                isSlider
              />) : (
              <CustomGetaways benefits={benefitsStore?.benefits} noPaddingTop isFromHome />) : null}

          <Banner type={PRIMARY_BANNER_TYPE} />
          
          <LifeStyleMessage />

          <FeaturedDestinations isVacationRentals={isVacationRentals} />

          {!contactSectionBottom && hasDisplayContactSection ? (<Contact />) : null}

          {!hideThingsMatterSection ? (
            <SearchBenefits />) : null}

          {hasDisplayTrustedBrandsSection ? (<CompanyLogos logos={HotelsCompanyLogos} />) : null}

          <AboutUs />

          {contactSectionBottom && hasDisplayContactSection ? (<Contact />) : null}

          <Banner type={SECONDARY_BANNER_TYPE} />
        </>
      )}

      {hotels && loading && isEmpty(error) ? 
        <SkeletonResult label={searchedLocation} /> : null}

      {(hotels || !isEmpty(error)) && !loading ? (
        <Responsive>
          <ResultWrapper label={searchedLocation} isVacationRentals={isVacationRentals} />
        </Responsive>
      ) : null}
    </div>
  );
}
